import { Client, ClientWithoutServices } from '../components/clients/types';

export const clientSearchFunction = (
  text: string,
  client: Client | ClientWithoutServices,
) => {
  const _text = text.toLowerCase();
  return (
    client.email?.toLowerCase().includes(_text) ||
    client.volcanoEmail?.toLowerCase().includes(_text) ||
    client.phone?.toLowerCase().includes(_text) ||
    client.volcanoClientId?.toLowerCase().includes(_text) ||
    client.id?.toLowerCase().includes(_text) ||
    client.name?.toLowerCase().includes(_text) ||
    client.alternatePhone?.toLowerCase().includes(_text) ||
    client.nif?.toLowerCase().includes(_text)
  );
};
